










































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IEditParams, IImgColor, ISourceType, IUploadParams } from '@/store/tool/imgcolor/types';
import ToolImgColorEdit from '@/views/tool/imgcolor/Edit.vue';
import ToolImgColorPreview from '@/views/tool/imgcolor/Preview.vue';
import ToolImgColorUpload from '@/views/tool/imgcolor/Upload.vue';
import ToolImgColorList from '@/views/tool/imgcolor/List.vue';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';
import copy from '@/utils/clipboard';

const ImgColor = namespace('tool/imgcolor');

// 图片取色
@Component({
  components: { ToolImgColorUpload, ToolImgColorPreview, ToolImgColorList, ToolImgColorEdit, TooltipIcon },
})
export default class ToolImgColor extends Vue {
  @ImgColor.Action('uploadImg') public uploadImg!: (params: IUploadParams) => void;
  @ImgColor.Mutation('setImgColor') public setImgColor!: (params: Partial<IImgColor>) => void;
  @ImgColor.State('imgcolor') public imgcolor!: IImgColor;

  @ImgColor.Action('modifyImg') public modifyImg!: (params: IEditParams) => void;
  @ImgColor.State('params') public params!: IEditParams;
  @ImgColor.State('loading') public loading!: boolean;

  @Ref('form') public formRef!: HTMLFormElement;
  @Prop({ type: Boolean, default: false }) public show!: boolean;

  public copyText = '';
  public source: ISourceType = 2;
  public formData = { colors: 6, brightAdjust: 0, saturationAdjust: 0 };

  // 是否有数据
  public get hasData() {
    return !!this.imgcolor.data;
  }

  public destroyed() {
    this.setImgColor({ data: null });
    this.copyText = '';
  }

  // 百分比转换为保留3位小数点的浮点数（js 浮点计算不准确)
  public percent2float(value: string) {
    const rs = value.split('.');
    const intStr = (parseInt(rs[0], 10) / 100).toFixed(2);
    const floatStr = rs[1].slice(0, rs[1].length - 1);
    return `${intStr}${floatStr}`;
  }

  // 清除数据
  public onClearData() {
    this.setImgColor({ data: null });
  }

  // 确认上传
  public async onUpload(params: FormData | null) {
    if (params) {
      await this.uploadImg(params as unknown as IUploadParams);
      this.formData = { ...this.params };
      this.copyText = '';
    }
  }

  // 保存编辑
  public onSave() {
    if (this.formRef.validate()) {
      const imgKey = this.imgcolor.data ? this.imgcolor.data.thumbKey : '';
      const { colors, brightAdjust, saturationAdjust } = this.formData;
      const params = new FormData();
      params.append('imgKey', imgKey);
      params.append('colors', colors as unknown as string);
      params.append('brightAdjust', brightAdjust as unknown as string);
      params.append('saturationAdjust', saturationAdjust as unknown as string);
      this.modifyImg(params as unknown as IEditParams);
      this.copyText = '';
    }
  }

  // 列表变更时(移除操作时)
  public onListChange(value: Array<{ hex: string; percent: string }>) {
    const colors = value.map((item) => ({ perc: this.percent2float(item.percent), color: item.hex }));
    const dominantColor = colors[0]?.color || '';
    this.copyText = JSON.stringify({ dominantColor, colors });
  }

  // 复制列表数据
  public onCopy() {
    if (!this.copyText) {
      const raw = this.imgcolor.data?.pallete || [];
      const dominantColor = raw[0]?.color || '';
      const colors = raw.map((item) => ({ perc: item.perc, color: item.color }));
      this.copyText = JSON.stringify({ dominantColor, colors });
    }
    copy(this.copyText);
  }

  // 显示或隐藏时, 重置表单数据
  @Watch('show')
  public showChange(value: boolean) {
    if (value) {
      this.formData = { ...this.params };
    }
  }
}
